import React from 'react';
import { Moment } from 'moment';
import SideFilter from '../../../../../Components/Filter/SideFilter';
import SideFilterForm from '../../../../../Components/Filter/SideFilterForm/SideFilterForm';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import { NCZIReferenceSelectItem } from '../../ReferenceSearchSelect/NCZIReferenceSearchSelect';

export interface ElectronicExaminationFilterValues {
	dateFrom?: Moment;
	dateTo?: Moment;
	ownRecords?: boolean;
	typesZoov?: boolean;
	typesZps?: boolean;
	typesZozv?: boolean;
	sensitivity?: SelectValue;
	expertise?: NCZIReferenceSelectItem;
}

interface Props {
	onFilter: (values: ElectronicExaminationFilterValues) => void;
}

const ElectronicExaminationFilterScheme: ItemScheme[] = [
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.examination.filter.writeDateFrom',
		key: 'dateFrom',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.examination.filter.writeDateTo',
		key: 'dateTo',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.SELECT,
		title: 'nczi.examination.filter.sensitivity',
		key: 'sensitivity',
		settings: {
			hideRequired: true,
		},
		children: [
			{
				key: '0',
				title: 'base.shared.pick',
				value: '0',
			},
			{
				key: '1',
				title: '1',
				value: '1',
			},
			{
				key: '2',
				title: '2',
				value: '2',
			},
			{
				key: '3',
				title: '3',
				value: '3',
			},
			{
				key: '4',
				title: '4',
				value: '4',
			},
			{
				key: '5',
				title: '5',
				value: '5',
			},
		]
	},
	{
		type: MagicField.NZCI_SPECIALIZATION,
		title: 'nczi.examination.filter.expertise',
		key: 'expertise',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.examination.filter.types.title',
	},
	{
		type: MagicField.CHECKBOX,
		title: 'nczi.examination.filter.types.zoov',
		key: 'typesZoov',
	},
	{
		type: MagicField.CHECKBOX,
		title: 'nczi.examination.filter.types.zps',
		key: 'typesZps',
	},
	{
		type: MagicField.CHECKBOX,
		title: 'nczi.examination.filter.types.zozv',
		key: 'typesZozv',
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.electronicDPN.filter.recordsLabel',
	},
	{
		type: MagicField.CHECKBOX,
		title: 'nczi.examination.filter.onlyOwnRecords',
		key: 'ownRecords',
	},
];

const ElectronicExaminationFilter: React.FC<Props> = ({ onFilter }) => {
	const handleOnSubmit = (values: any) => {
		onFilter(values as ElectronicExaminationFilterValues);
	};

	return (
		<SideFilter isOpenByDefault={false}>
			<SideFilterForm
				onSubmit={handleOnSubmit}
				formScheme={ElectronicExaminationFilterScheme}
				defaultValues={{}}
			/>
		</SideFilter>
	);
};

export default ElectronicExaminationFilter;
